
/* Rohini 10/29/2022 3075154998 add classname globally for the textfields and buttons */
import React, {useEffect, useContext, useState} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {useDispatch} from 'react-redux';
import * as Yup from 'yup';
import {getDropDownData} from '../../../../../../redux/reducers/EnableFramework/Filter';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import GuiAutoComplete from '../../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../../components/FormComponents/GuiTextField';

const ConditionForm = ({
  setConditionData,
  conditionData,
  setFilterOpen,
  handleConditionClose,
  conditionRowData,
  isConditionEditMode,
  setIsConditionEditMode,
  conditionCode,
  ruleGroupSNo,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  let initialValues = {
    code: isConditionEditMode ?
      conditionRowData && conditionRowData.code :
      ruleGroupSNo ?
        ruleGroupSNo > 9 ?
          'R' + ruleGroupSNo :
          'R0' + ruleGroupSNo :
        isConditionEditMode && conditionRowData && conditionRowData.code ?
          conditionRowData.code :
          '',
    operator: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : '',
    toField: isConditionEditMode && conditionRowData?.toField ? conditionRowData?.toField : '',
    fieldCode:
      isConditionEditMode && conditionRowData?.fieldCode ? conditionRowData?.fieldCode : '',
    srcField: isConditionEditMode && conditionRowData?.srcField ? conditionRowData?.srcField : '',
    dateFormat:
      isConditionEditMode && conditionRowData?.dateFormat ? conditionRowData?.dateFormat : '',
  };
  const [currentRuleCode, setCurrentRuleCode] = useState(conditionRowData?.code || '');

  useEffect(() => {
    initialValues = {
      code: isConditionEditMode ?
        conditionRowData && conditionRowData.code :
        ruleGroupSNo ?
          ruleGroupSNo > 9 ?
            'R' + ruleGroupSNo :
            'R0' + ruleGroupSNo :
          isConditionEditMode && conditionRowData && conditionRowData.code ?
            conditionRowData.code :
            '',
      operator: isConditionEditMode && conditionRowData?.operator ? conditionRowData?.operator : '',
      toField: isConditionEditMode && conditionRowData?.toField ? conditionRowData?.toField : '',
      fieldCode:
        isConditionEditMode && conditionRowData?.fieldCode ? conditionRowData?.fieldCode : '',
      srcField: isConditionEditMode && conditionRowData?.srcField ? conditionRowData?.srcField : '',
      dateFormat:
        isConditionEditMode && conditionRowData?.dateFormat ? conditionRowData?.dateFormat : '',
    };
  }, [conditionRowData]);
  const dateFormatOptions = [
    {key: 'MDY', value: 'MDY'},
    {key: 'YMD', value: 'YMD'},
  ];

  const handleSubmit = (data) => {
    const copiedData = [...conditionData];
    if (!isConditionEditMode) {
      copiedData.push({...data});
      setConditionData(copiedData);
      setFilterOpen(false);
    } else {
      const updatedActionData = copiedData.map((item, i) => {
        if (i === conditionCode) {
          return {
            ...item,
            code: data?.code,
            operator: data?.operator,
            fieldName: data?.fieldName,
            fieldCode: data?.fieldCode,
            dateorField: data?.dateorField,
            dateFormat: data?.dateFormat,
            seqNo: i + 1,
            srcField: data.srcField,
            toField: data?.toField,
          };
        } else {
          return {...item};
        }
      });
      setConditionData(updatedActionData);
      setFilterOpen(false);
      setIsConditionEditMode(false);
    }
  };
  useEffect(() => {
    dispatch(getDropDownData());
  }, []);
  const schema = Yup.object().shape({
    code:
      conditionRowData?.code === currentRuleCode && isConditionEditMode ?
        '' :
        Yup.string()
          .notOneOf(
            conditionData.map((data) => data.code),
            'Rule code already exists',
          )
          .required('Rule Code is required').nullable(),
  });
  return (
    <div className={classes.dialoguecardStyles}>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={schema}
        enableReinitialize
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            setFieldValue,
          } = props;
          return (
            <div>
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div>
                  <Grid container className="global-field-textfields" spacing={2}>
                    <Grid item xs={6} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        placeholder={`Enter Code`}
                        label="Code"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="code"
                        required
                        disabled
                        value={values.code}
                        onChange={(e) => {
                          setCurrentRuleCode(e.target.value);
                          handleChange(e);
                        }}
                        onBlur={handleBlur}
                        fullWidth
                        touched={touched.code}
                        error={Boolean(touched.code && errors.code)}
                      />
                      <FormHelperText style={{color: 'red'}}>
                        {touched.code && errors.code && errors.code}
                      </FormHelperText>
                    </Grid>
                    <Grid item xs={6} className="form-group">
                      <TextField
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        margin="dense"
                        variant="outlined"
                        placeholder="Enter To Field"
                        label="To Field"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="toField"
                        value={values.toField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} className="form-group">
                      <TextField
                        margin="dense"
                        variant="outlined"
                        className={` ${classes.labelName} ${classes.inputLabel}`}
                        placeholder={`Enter Expression`}
                        label="Expression"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="operator"
                        value={values.operator}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6} className="form-group">
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        name="dateFormat"
                        id="dateFormat"
                        size="small"
                        value={values.dateFormat}
                        options={dateFormatOptions.map((item) => item.value)}
                        onChange={(e, value) => {
                          setFieldValue('dateFormat', value);
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              className={` ${classes.labelName} ${classes.selectLabel}`}
                              margin="dense"
                              InputLabelProps={{
                                shrink: true,
                              }}
                              label="Date Format"
                              placeholder="Select Date Format"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                  </Grid>
                </div>
                <div className="text-center">
                  <div className="row justify-content-center mb-1">
                    <Button
                      type="button"
                      onClick={() => handleReset()}
                      variant="outlined"
                      className={`mx-1 reset-btn`}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="outlined"
                      className={`mx-1 search-btn`}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default ConditionForm;
